import React from 'react';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const AreaLineChart = ({ chartData, apiLoading, height = 350, isMultiLines = true }) => {

    const monthlyChart = {
        chart: {
            type: "areaspline", // 👈 smooth area
            backgroundColor: "transparent",
            height: height,
        },

        title: { text: "" },

        xAxis: {
            categories: chartData?.categories || [],
            tickLength: 0,
            lineColor: "#E5E7EB",
            gridLineWidth: 0,
            labels: {
                style: {
                    color: "#6B7280",
                    fontSize: "12px",
                },
            },
        },

        yAxis: {
            title: { text: "" },
            gridLineColor: "#E5E7EB",
            gridLineDashStyle: "Dot", // 👈 dotted grid like screenshot
            labels: {
                style: {
                    color: "#6B7280",
                    fontSize: "12px",
                },
            },
        },

        legend: { enabled: isMultiLines }, // 👈 single chart look

        plotOptions: {
            areaspline: {
                lineWidth: 2,
                fillOpacity: 1,
                marker: {
                    enabled: true,
                    radius: 5,
                    lineWidth: 2,
                    lineColor: "#ffffff",
                    fillColor: "#3B82F6",
                },
                states: {
                    hover: {
                        lineWidth: 2,
                    },
                },
            },
        },

        series: chartData?.data || [],

        tooltip: {
            shared: true,
            backgroundColor: "#ffffff",
            borderColor: "#E5E7EB",
            borderRadius: 8,
            shadow: true,
            valueDecimals: 0,
        },

        credits: { enabled: false },
    }
    return <HighchartsReact highcharts={Highcharts} options={monthlyChart} />
}

export default AreaLineChart
